export default __webpack_public_path__ + "static/media/habrImg6.ff7e377d.jpeg";